import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout";

import BankAcRoutes from './modules/bankAccount'
import PaymentRoutes from './modules/payment'
import OrderRoutes from './modules/order'
import VueCookie from "vue-cookie";

Vue.use(Router);

export const uRoutes = [
    {
        path: "/",
        redirect: "/project/detail",
        component: Layout,
        name: "Home",
        meta: { title: "驾驶舱" }
    },
    {
        path: "/project",
        component: Layout,
        name: "Project",
        meta: { title: "项目" },
        children: [
            {
                path: "/project/detail",
                name: "ProjectDetail",
                component: () => import("@/view/project/detail"),
                meta: { title: "项目详情" }
            }
        ]
    },
    {
        path: "/pmc",
        component: Layout,
        name: "Pmc",
        meta: { title: "pmc" },
        children: [
            {
                path: "/pmc/productLine",
                name: "ProductLine",
                component: () => import("@/view/pmc/productLine"),
                meta: { title: "产品线" }
            },
        ]
    },
    {
        path: "/brand",
        component: Layout,
        name: "brand",
        meta: { title: "brand" },
        children: [
            {
                path: "/brand/branding",
                name: "branding",
                component: () => import("@/view/brand/branding"),
                meta: { title: "自主品牌推广" }
            },
        ]
    },
    {
        path: "grossProfit",
        component: Layout,
        name: "grossProfit",
        meta: { title: "grossProfit" },
        children: [
            {
                path: "/grossProfit/grossindex",
                name: "grossProfit",
                component: () => import("@/view/grossProfit/grossindex"),
                meta: { title: "毛利率" }
            },
        ]
    },
    {
        path: "/partner",
        component: Layout,
        redirect: "/partner/map",
        name: "CustomerTree",
        meta: { title: "CustomerTree" },
        children: [
            {
                path: "/partner/map",
                name: "CustomerTree",
                component: () => import("@/view/customertree/index"),
                meta: { title: "客户档案"}
            },
            {
                path: "/partner/detail",
                name: "CustomerTree",
                component: () => import("@/view/customertree/index"),
                meta: { title: "客户档案" }
            },
            {
                path: "/partner/payment_process",
                name: "PaymentProcess",
                component: () => import("@/view/paymentProcess/index"),
                meta: { title: "付款流程" }
            }
        ]
    },
    {
        path: "saleTools",
        component: Layout,
        name: "SaleTools",
        meta: { title: "销售标准工具" },
        children: [
            {
                path: "/saleTools/index",
                name: "SaleTools",
                component: () => import("@/view/saleTools/index"),
                meta: { title: "销售标准工具" }
            },
        ]
    },
    {
        path: "/pending",
        component: Layout,
        name: "PendingList",
        meta: { title: "客户档案待办事项清单" },
        children: [
            {
                path: "/pending/pending_list",
                name: "PendingList",
                component: () => import("@/view/pending/index.vue"),
                meta: { title: "客户档案待办事项清单" }
            },
            {
                path: "/pending/pending_add",
                name: "PendingCustomerAdd",
                component: () => import("@/view/pending/pendingCustomerAdd.vue"),
                meta: { title: "管理客户档案" }
            },
            {
                path: "/pending/pending_new",
                name: "PendingCustomerAddNew",
                component: () => import("@/view/pending/pendingCustomerAddNew.vue"),
                meta: { title: "管理客户档案" }
            },
            {
                path: "/pending/pending_bd",
                name: "PendingCustomerAddBd",
                component: () => import("@/view/pending/pendingCustomerAddBd.vue"),
                meta: { title: "管理客户档案" }
            },
            {
                path: "/pending/pending_draft",
                name: "PendingCustomerAddDraft",
                component: () => import("@/view/pending/pendingCustomerAddDraft.vue"),
                meta: { title: "管理客户档案" }
            },
        ]
    },
    {
        path: "/saleTools",
        component: Layout,
        name: "SaleTools",
        meta: { title: "销售标准工具" },
        children: [
            {
                path: "/saleTools/index",
                name: "SaleTools",
                component: () => import("@/view/saleTools/index"),
                meta: { title: "销售标准工具" }
            },
        ]
    },
    {
        path: "/factory",
        component: Layout,
        name: "starterFollow",
        meta: { title: "厂家自主跟单" },
        children: [
            {
                path: "/factory/starter/follow",
                name: "starterFollow",
                component: () => import("@/view/factory/starter_follow"),
                meta: { title: "厂家自主跟单" }
            },
            {
                path: "/factory/absin/follow",
                name: "absinFollow",
                component: () => import("@/view/factory/absin_follow"),
                meta: { title: "厂家自主跟单" }
            },
            {
                path: "/factory/ua/follow",
                name: "uaFollow",
                component: () => import("@/view/factory/ua_follow"),
                meta: { title: "厂家自主跟单" }
            },
            {
                path: "/factory/absin/unit/follow",
                name: "absinUnitFollow",
                component: () => import("@/view/factory/absin_unit_follow"),
                meta: { title: "组织间需求单跟单" }
            },
            {
                path: "/factory/starter/unit/follow",
                name: "starterUnitFollow",
                component: () => import("@/view/factory/starter_unit_follow"),
                meta: { title: "组织间需求单跟单" }
            },
            {
                path: "/factory/ua/unit/follow",
                name: "uaUnitFollow",
                component: () => import("@/view/factory/ua_unit_follow"),
                meta: { title: "组织间需求单跟单" }
            },
        ]
    },

    {
        path: "/partner",
        component: Layout,
        redirect: "/partner/map",
        name: "CustomerTree",
        meta: { title: "CustomerTree" },
        children: [
            {
                path: "/partner/map",
                name: "CustomerTree",
                component: () => import("@/view/customertree/index"),
                meta: { title: "客户档案"}
            },
            {
                path: "/partner/detail",
                name: "CustomerTree",
                component: () => import("@/view/customertree/index"),
                meta: { title: "客户档案" }
            },
        ]
    },
    {
        path: "/handover",
        component: Layout,
        redirect: "/handover/business",
        name: "HandoverBusiness",
        meta: { title: "HandoverBusiness" },
        children: [
            {
                path: "/handover/business",
                name: "HandoverBusiness",
                component: () => import("@/view/handover/index"),
                meta: { title: "业务交接"}
            }
        ]

    },
    {
        path: "/invoiceProcess",
        component: Layout,
        redirect: "/invoiceProcess/index",
        name: "InvoiceProcess",
        meta: { title: "InvoiceProcess" },
        children: [
            {
                path: "/oms/self/invoice/process",
                name: "InvoiceProcess",
                component: () => import("@/view/invoiceProcess/index"),
                meta: { title: "自助报账"}
            },
            {
                path: "/oms/self/invoice/preview",
                name: "InvoiceProcess",
                component: () => import("@/view/invoiceProcess/invoicePreview"),
                meta: { title: "发票预览"}
            }
        ]

    },
    {
        path: "/account",
        component: Layout,
        name: "Account",
        meta: { title: "大客户" },
        children: [
            {
                path: "/account",
                name: "Account",
                component: () => import("@/view/account/index"),
                meta: { title: "大客户" }
            },
        ]
    },
    {
        path: "/subAccount",
        component: Layout,
        name: "SubAccount",
        meta: { title: "二级部门大客户" },
        children: [
            {
                path: "/subAccount",
                name: "SubAccount",
                component: () => import("@/view/subAccount/index"),
                meta: { title: "二级部门大客户" }
            },
        ]
    },
    // 网银流水
    BankAcRoutes,
    // 订单中心
    OrderRoutes,
    //催款收款
    PaymentRoutes,
    {
        path: "/404",
        component: () => import("@/view/404"),
        name: "404",
        meta: { title: "404未找到" }
    },
    { path: "*", redirect: "/404" }
];

const createRouter = () =>
    new Router({
        mode: "history",
        // mode: 'hash',
        scrollBehavior: () => ({ y: 0 }),
        routes: uRoutes
    });

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
     // 获取当前token
    const token = VueCookie.get('token');

    // 如果有token，且location是对象类型（包含path和query）
    if (token && typeof location === 'object' && location.name) {
        // 确保query对象存在
        location.query = location.query || {};
        // 无论是否已有token，都替换为新的token
        location.query.token = token;
    }

    // 如果location是字符串路径
    if (token && typeof location === 'string') {
        // 检查路径是否已经包含token参数
        if (location.includes('token=')) {
            // 如果已有token参数，替换其值
            location = location.replace(/token=[^&]+/, `token=${token}`);
        } else {
            // 如果没有token参数，添加新的token参数
            const separator = location.includes('?') ? '&' : '?';
            location += `${separator}token=${token}`;
        }
    }
    return originalPush.call(this, location).catch(err => err);
};
const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js